import {atom, useRecoilState} from "recoil";

const dataResponse = atom({
    key: 'mode',
    default: {
        "safetyScoreData": {
            "np": 45,
            "pm": 0,
            "percentage": 334,
            "regionName": "Zürich",
            "a": 0.23402412055000002,
            "xFactor_n": 2,
            "xFactor_m": 3,
            "r": 1.01465061438894,
            "n": 0.46804824110000004,
            "m": 0.07800804018333334,
            "lengthIn10km": 164,
            "annualAvgAccidents10km": 301.09090909090907
        },
        "map300m": {
            "mainPoint": {"latitude": 47.38933712416473, "longitude": 8.536339269775398},
            "hotSpots": [{
                "latitude": 47.3855082953359,
                "longitude": 8.530434678519695
            }, {"latitude": 47.391544331371946, "longitude": 8.542641923362892}, {
                "latitude": 47.391364151191766,
                "longitude": 8.53614023860945
            }, {"latitude": 47.386769556597166, "longitude": 8.53919204982025}, {
                "latitude": 47.38712991695753,
                "longitude": 8.535078739057868
            }]
        },
        "map10km": {
            "mainPoint": {"latitude": 47.38933712416473, "longitude": 8.536339269775398},
            "hotSpots": [{"latitude": 47.38460739443501, "longitude": 8.53202692784706}, {
                "latitude": 47.38685964668726,
                "longitude": 8.547285983901096
            }, {"latitude": 47.3819046917323, "longitude": 8.529373178968097}, {
                "latitude": 47.37694973677734,
                "longitude": 8.543305360582652
            }, {"latitude": 47.388210998038616, "longitude": 8.520085057891727}]
        },
        "casualtyAge": {"0-17": 12, "18-25": 21, "26-64": 52, "over 65": 15},
        "casualtySeverity": {"NoInjuries": 0, "Moderate": 83, "Serious": 16, "Fatal": 0},
        "casualtyUserGroup": {"Cars": 32, "Motorcycles": 16, "Bikes": 39, "Pedestrians": 18, "Other": -4},
        "accidentsTrends": [{"year": 2017, "percentage": -11, "accidentsCount": 304}, {
            "year": 2018,
            "percentage": 16,
            "accidentsCount": 354
        }, {"year": 2019, "percentage": -12, "accidentsCount": 309}, {
            "year": 2020,
            "percentage": -4,
            "accidentsCount": 296
        }, {"year": 2021, "percentage": -2, "accidentsCount": 290}],
        "weatherStatistic": {"wetRoad": 12, "precipitation": 9, "goodWeather": 54},
        "nightAccidents": 14,
        "accidentsByDayAndTime": {
            "mon": [[1, 1], [2, 1], [3, 2], [4, 2], [5, 1], [6, 12], [7, 28], [8, 22], [9, 31], [10, 19], [11, 26], [12, 26], [13, 26], [14, 28], [15, 26], [16, 35], [17, 46], [18, 30], [19, 29], [20, 28], [21, 9], [22, 14], [23, 5], [24, 1]],
            "tue": [[1, 5], [2, 0], [3, 0], [4, 1], [5, 4], [6, 11], [7, 38], [8, 35], [9, 24], [10, 23], [11, 19], [12, 21], [13, 28], [14, 21], [15, 35], [16, 41], [17, 49], [18, 40], [19, 30], [20, 12], [21, 16], [22, 9], [23, 4], [24, 5]],
            "wed": [[1, 2], [2, 1], [3, 1], [4, 4], [5, 4], [6, 13], [7, 29], [8, 36], [9, 31], [10, 18], [11, 36], [12, 28], [13, 22], [14, 37], [15, 36], [16, 42], [17, 49], [18, 44], [19, 28], [20, 30], [21, 19], [22, 20], [23, 20], [24, 6]],
            "thu": [[1, 5], [2, 4], [3, 2], [4, 3], [5, 2], [6, 11], [7, 23], [8, 39], [9, 21], [10, 21], [11, 20], [12, 28], [13, 28], [14, 32], [15, 30], [16, 35], [17, 60], [18, 38], [19, 25], [20, 18], [21, 16], [22, 14], [23, 14], [24, 8]],
            "fri": [[1, 14], [2, 6], [3, 3], [4, 1], [5, 7], [6, 5], [7, 27], [8, 38], [9, 23], [10, 28], [11, 20], [12, 27], [13, 32], [14, 34], [15, 38], [16, 40], [17, 48], [18, 43], [19, 18], [20, 22], [21, 25], [22, 16], [23, 19], [24, 11]],
            "sat": [[1, 19], [2, 17], [3, 11], [4, 11], [5, 13], [6, 8], [7, 9], [8, 5], [9, 16], [10, 19], [11, 17], [12, 30], [13, 26], [14, 29], [15, 27], [16, 33], [17, 33], [18, 28], [19, 29], [20, 11], [21, 12], [22, 14], [23, 24], [24, 28]],
            "sun": null
        }
    }
})
export const useDataResponse = () => {
    return useRecoilState(dataResponse)
}
const address = atom({
    key: 'address',
    default: ''
})
const markers = atom({
    key: 'markers',
    default: {lat: '47.46129320831824', lng: '8.553476140592133'}
})
export const useAddressPosition = () =>{
    return useRecoilState(address)
}
export const useMarkersPosition = () =>{
    return useRecoilState(markers)
}
const menu = atom({
    key: 'menu',
    default: window.innerWidth < 425
})
export const useMenu = () => {
    return useRecoilState(menu)
}
const queryParameters = atom({
    key: 'queryParameters',
    default: {
        Email:  "",
        id:111111,
        CompanyName: "K2Go",
        Language: 'uk',
    }
})
export const useQueryParameters = () => {
    return useRecoilState(queryParameters)
}